var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H3C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03033 7.96967C6.73744 7.67678 6.26256 7.67678 5.96967 7.96967L2.46967 11.4697C2.17678 11.7626 2.17678 12.2374 2.46967 12.5303L5.96967 16.0303C6.26256 16.3232 6.73744 16.3232 7.03033 16.0303C7.32322 15.7374 7.32322 15.2626 7.03033 14.9697L4.06066 12L7.03033 9.03033C7.32322 8.73744 7.32322 8.26256 7.03033 7.96967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 4C8.25 3.58579 8.58579 3.25 9 3.25H21C21.4142 3.25 21.75 3.58579 21.75 4V14C21.75 14.4142 21.4142 14.75 21 14.75C20.5858 14.75 20.25 14.4142 20.25 14V4.75H9.75V7C9.75 7.41421 9.41421 7.75 9 7.75C8.58579 7.75 8.25 7.41421 8.25 7V4ZM9 16.25C9.41421 16.25 9.75 16.5858 9.75 17V19.25H20.25V18C20.25 17.5858 20.5858 17.25 21 17.25C21.4142 17.25 21.75 17.5858 21.75 18V20C21.75 20.4142 21.4142 20.75 21 20.75H9C8.58579 20.75 8.25 20.4142 8.25 20V17C8.25 16.5858 8.58579 16.25 9 16.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1dd821774093ceadce3dfd0d44630d8a.svg";
export { ForwardRef as ReactComponent };